/* eslint-disable react/prop-types */
import React, { FunctionComponent, useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, DialogActions, Grid, CircularProgress, Box } from "@material-ui/core";
import DropZone from "../../DropZone";
import API from "../../../helpers/apiHelpers";
import { useSnackbar } from "notistack";

interface Props {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
	imageUploadURL: string;
	onLoad: any;
	setLoaded?: React.Dispatch<React.SetStateAction<boolean>> | null;
	vetId?: number | null,
}

const UploadPhotoModal: FunctionComponent<Props> = ({
    isOpen,
    onClose,
    imageUploadURL,
    onLoad,
    setLoaded=null,
    vetId=null
}) => {
    const [loadedPhoto, setLoadedPhoto] = useState(null);
    const [loader, setLoader] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const handleLoad = () => {
        setLoader(true);
        fetch(loadedPhoto)
            .then(res => res.blob())
            .then(res => API.uploadToAWS(imageUploadURL, res))
            .then(res => (onLoad(res), setLoader(false)))
            .catch(console.warn)
            .finally(() => {setLoader(false); if (setLoaded) {setLoaded(true);}});
        setLoadedPhoto(null);
    };

    const getURLs = () => {
        const urls = API.getLiscenseUrls(vetId)
            .then((res) => {
                return res.uploadUrl;
            });
        return urls;
    };

    const handleLoadLicense = async () => {
        const uploadUrl = await getURLs();
        setLoader(true);
        fetch(loadedPhoto)
            .then(res => res.blob())
            .then(res => API.uploadToAWS(uploadUrl, res))
            .then(res => (onLoad(res), setLoader(false)))
            .catch(console.warn)
            .finally(() => {setLoader(false); if (setLoaded) {setLoaded(true);}});
        setLoadedPhoto(null)
    };

    const handleLoadPhoto = (val) => {
        if (val.includes("/jpg;") || val.includes("/png;") || val.includes("/jpeg;")) {
            setLoadedPhoto(val);
        }else {
            enqueueSnackbar("That file type is not supported. Please try again with a '.jpg', '.png', or '.jpeg'.", {
                variant: "error",
                autoHideDuration: 3000,
            });
        }
    };

    return (
        <Dialog
            onClose={onClose}
            open={isOpen}
            disableEnforceFocus
            aria-labelledby="upload-photo-title"
            aria-describedby="upload-photo-main"
        >
            <DialogTitle id="upload-photo-title">Upload your photo</DialogTitle>
            <DialogContent>
                {loader ?
                    <Grid container justify="center">
                        <Box height="140px" justifyContent="center" alignItems="center">
                            <CircularProgress size={60}/>
                        </Box>
                    </Grid> :
                    <Grid container justify="center">
                        {
                            <DropZone onLoad={handleLoadPhoto} photo={loadedPhoto} deletePhoto={() => setLoadedPhoto(null)}/>
                        }
                    </Grid>}
            </DialogContent>
            <DialogActions>
                <Button type="button" onClick={vetId ? handleLoadLicense : handleLoad} color="primary" disabled={!loadedPhoto}>
					Upload
                </Button>
                <Button type="button" onClick={() => {onClose(false);}} color="primary">
					Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UploadPhotoModal;
